import React from 'react';
import _get from 'lodash/get';
import { Paper, makeStyles } from '@material-ui/core';
import { useQuery } from 'react-query';
import ListenNotesImg from 'containers/Podcast/images/power-ln.png';
import { fetchListenNotesData } from 'components/AudioCard';
import LoadingIndicator from 'components/LoadingIndicator';
import Player from 'components/AudioCard/Player';
import { EpisodesList } from 'containers/Podcast/components/EpisodesList';

const useStyles = makeStyles(theme => ({
  container: {
    borderRadius: props => !props.isMobile && '8px !important',
    overflow: 'hidden',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px !important',
    padding: '14px 9px 24px 18px',
    [theme.breakpoints.between(1024, 1600)]: {
      padding: '10px 9px 0px',
    },
  },
  playerRoot: {
    '& img': {
      height: 'auto',
    },
  },
  playerSeekBar: {
    background: '#fff',
  },
  listenNotesImg: {
    height: 13,
    marginLeft: 'auto',
  },
  imageContainer: {
    padding: '20px 0px',
    borderBottom: '1px solid #E0E0E0',
    textAlign: 'center',

    '& img': {
      width: 100,
      height: 100,
    },

    [theme.breakpoints.between(1024, 1600)]: {
      padding: '10px 0px',

      '& img': {
        width: 80,
        height: 80,
      },
    },
  },
  episodeRoot: {
    padding: '0px 0px 0px 9px',
    [theme.breakpoints.between(1024, 1600)]: {
      marginTop: 10,
    },
  },
  episodeTitle: {
    fontSize: props => props.isMobile && '1rem',
  },
  btnContainer: {
    marginTop: 10,
  },
}));

export const SeriesPodcastPreview = ({
  item,
  trackingProps,
  isMobile,
  isTablet,
  isBigTablet,
  podcastEpisodeSiteCopy,
  onProgressUpdate,
  initialTime,
  completed,
}) => {
  const classes = useStyles({ isMobile });
  const { data, status } = useQuery(
    [
      'listenotes',
      {
        finalType: _get(item, 'fields.type'),
        listenNotesId: _get(item, 'fields.listenNotesId'),
      },
    ],
    fetchListenNotesData,
  );

  const episode = _get(data, 'data.episodes.0') || _get(data, 'data');

  if (isMobile || isBigTablet || isTablet) {
    return (
      <div className={classes.container}>
        {status === 'success' ? (
          <Player
            customClasses={classes}
            trackingProps={trackingProps}
            data={data.data}
            thumbnail={episode.thumbnail}
            audio={episode.audio}
            onProgressUpdate={onProgressUpdate(item, completed)}
            initialTime={initialTime}
          />
        ) : (
          <LoadingIndicator />
        )}
      </div>
    );
  }

  const title = _get(podcastEpisodeSiteCopy, 'pageCopy.title');
  const listenNotes = episode ? [episode] : [];

  const episodesInitialTime = episode &&
    initialTime && {
      [episode.id]: initialTime,
    };

  return (
    <Paper elevation={0} className={classes.paper}>
      {status === 'loading' ? (
        <LoadingIndicator />
      ) : (
        <>
          <img
            className={classes.listenNotesImg}
            src={ListenNotesImg}
            alt="Powered by ListenNotes"
          />
          <div className={classes.imageContainer}>
            <img
              src={_get(item, 'fields.imageUrl') || _get(episode, 'thumbnail')}
              alt="Podcast"
              onError={event => {
                if (event.target.src !== _get(episode, 'thumbnail')) {
                  // eslint-disable-next-line no-param-reassign
                  event.target.onerror = '';
                  // eslint-disable-next-line no-param-reassign
                  event.target.src = _get(episode, 'thumbnail');
                  return true;
                }
                return false;
              }}
            />
          </div>
          <EpisodesList
            customClasses={classes}
            listenNotes={listenNotes}
            podcastEpisodeSiteCopy={podcastEpisodeSiteCopy}
            title={title}
            trackingProps={trackingProps}
            episodesInitialTime={episodesInitialTime}
            onProgressUpdate={onProgressUpdate(item, completed)}
            inPage={false}
          />
        </>
      )}
    </Paper>
  );
};
